export default __webpack_public_path__ + "static/media/icon-yahoo.602bb942.svg";